/*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/

import React from 'react';
import ReactDOM from 'react-dom';
import DetailModal from './modal/DetailModalComponent';
import SubStepOneModal from './modal/SubscribeStepOneModal';
import SubStepTwoModal from './modal/SubscribeStepTwoModal';
import { TopControlF } from './TopControlComponent';
import ResultHeader from './ResultHeaderComponent';
import ResultRow from './ResultRowComponent';
import SubStepThreeModal from './modal/SubscribeStepThreeModal';
import { Flight } from '../../../models/flight';


export interface SearchPageState {
    isSpanish: boolean;
    notifications: boolean;
    flights: Flight[];
    filteredFlights: Flight[];
    airlineList: string[];
    cityList: string[];
    defaultInput: string;
    citySelect: string;
    airlineSelect: string;
    terminalSelect: string;
    showCodeShares: false;
    isArrival: boolean;
    initialLoad: true;
    loadNumber: number;
    airlineSort: number | null;
    flightNumberSort: number | null;
    destinationSort: number | null;
    scheduleSort: number | null;
    terminalSort: number | null;
    gateSort: number | null;
    statusSort: number | null;
    bagClaimSort: number | null;
    sortColumn: number | null;
    isDetailModalShowing: boolean;
    isSubStepOneModalShowing: boolean;
    isSubStepTwoModalShowing: boolean;
    isSubStepThreeModalShowing: boolean;
    notificationMethod: number;
    modalModel: Flight;
    token: string | null;
    userInfo: string;
}

class SearchPage extends React.Component<{}, SearchPageState> {
    refresher: any;
    mainInput: React.Ref<HTMLInputElement> = React.createRef();
    modalRef: React.Ref<any> = React.createRef();
    state: SearchPageState;
    constructor(props: any) {
        super(props);

        const isSpanish =
            window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';

        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (search, pos) {
                return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
            };
        }

        let urlParams = new URLSearchParams(window.location.search);
        let defaultInput = urlParams.get('Search');
        if (defaultInput === null || defaultInput === undefined) {
            defaultInput = '';
        } else {
            const charIndex = defaultInput.indexOf('(');
            defaultInput = defaultInput.slice(0, charIndex > 0 ? charIndex : defaultInput.length).trim();
        }
        let isArrival = urlParams.get('AD') === 'A' || urlParams.get('AD') !== 'D';
        const notifications = true;//urlParams.get('notifications') === 'true' || process.env.NODE_ENV !== 'production';

        this.state = {
            isSpanish,
            notifications,
            flights: [],
            filteredFlights: [],
            airlineList: [],
            cityList: [],
            defaultInput,
            citySelect: '',
            airlineSelect: '',
            terminalSelect: '',
            showCodeShares: false,
            isArrival,
            initialLoad: true,
            loadNumber: 125,
            airlineSort: null,
            flightNumberSort: null,
            destinationSort: null,
            scheduleSort: 1,
            terminalSort: null,
            gateSort: null,
            statusSort: null,
            bagClaimSort: null,
            sortColumn: null,
            isDetailModalShowing: false,
            isSubStepOneModalShowing: false,
            isSubStepTwoModalShowing: false,
            isSubStepThreeModalShowing: false,
            notificationMethod: 0,
            modalModel: {} as Flight,
            token: localStorage.getItem('mtoken'),
            userInfo: ''
        };
    }

    sortColumn = (column: number, inplace: boolean, filteredFlights: Flight[]) => {
        let value;
        if (filteredFlights === undefined || filteredFlights === null) {
            filteredFlights = this.state.filteredFlights;
        }

        let sortColumn = { sortColumn: column };
        switch (column) {
            case 1:
                value = this.state.airlineSort;
                let airlineSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Airline > b.Airline ? 1 : b.Airline > a.Airline ? -1 : 0,
                    );
                    airlineSort = { airlineSort: 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Airline < b.Airline ? 1 : b.Airline < a.Airline ? -1 : 0,
                    );
                    airlineSort = { airlineSort: 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Airline < b.Airline ? 1 : b.Airline < a.Airline ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Airline > b.Airline ? 1 : b.Airline > a.Airline ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            airlineSort,
                            { flightNumberSort: null },
                            { destinationSort: null },
                            { scheduleSort: null },
                            { terminalSort: null },
                            { gateSort: null },
                            { statusSort: null },
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 2:
                value = this.state.flightNumberSort;
                let flightNumberSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        //@ts-ignore
                        a.fn > b.fn ? 1 : b.fn > a.fn ? -1 : 0,
                    );
                    flightNumberSort = { flightNumberSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        //@ts-ignore
                        a.fn < b.fn ? 1 : b.fn < a.fn ? -1 : 0,
                    );
                    flightNumberSort = { flightNumberSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        //@ts-ignore
                        a.fn < b.fn ? 1 : b.fn < a.fn ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        //@ts-ignore
                        a.fn > b.fn ? 1 : b.fn > a.fn ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            flightNumberSort,
                            { destinationSort: null },
                            { scheduleSort: null },
                            { terminalSort: null },
                            { gateSort: null },
                            { statusSort: null },
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 3:
                value = this.state.destinationSort;
                let destinationSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Destination > b.Destination ? 1 : b.Destination > a.Destination ? -1 : 0,
                    );
                    destinationSort = { destinationSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Destination < b.Destination ? 1 : b.Destination < a.Destination ? -1 : 0,
                    );
                    destinationSort = { destinationSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Destination < b.Destination ? 1 : b.Destination < a.Destination ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Destination > b.Destination ? 1 : b.Destination > a.Destination ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            { flightNumberSort: null },
                            destinationSort,
                            { scheduleSort: null },
                            { terminalSort: null },
                            { gateSort: null },
                            { statusSort: null },
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 4:
                value = this.state.scheduleSort;
                let scheduleSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.TimeSortKey > b.TimeSortKey ? 1 : b.TimeSortKey > a.TimeSortKey ? -1 : 0,
                    );
                    scheduleSort = { scheduleSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.TimeSortKey < b.TimeSortKey ? 1 : b.TimeSortKey < a.TimeSortKey ? -1 : 0,
                    );
                    scheduleSort = { scheduleSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.TimeSortKey < b.TimeSortKey ? 1 : b.TimeSortKey < a.TimeSortKey ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.TimeSortKey > b.TimeSortKey ? 1 : b.TimeSortKey > a.TimeSortKey ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            { flightNumberSort: null },
                            { destinationSort: null },
                            scheduleSort,
                            { terminalSort: null },
                            { gateSort: null },
                            { statusSort: null },
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 5:
                value = this.state.terminalSort;
                let terminalSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Terminal > b.Terminal ? 1 : b.Terminal > a.Terminal ? -1 : 0,
                    );
                    terminalSort = { terminalSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Terminal < b.Terminal ? 1 : b.Terminal < a.Terminal ? -1 : 0,
                    );
                    terminalSort = { terminalSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Terminal < b.Terminal ? 1 : b.Terminal < a.Terminal ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Terminal > b.Terminal ? 1 : b.Terminal > a.Terminal ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            { flightNumberSort: null },
                            { destinationSort: null },
                            { scheduleSort: null },
                            terminalSort,
                            { gateSort: null },
                            { statusSort: null },
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 6:
                value = this.state.gateSort;
                let gateSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) => (a.Gate > b.Gate ? 1 : b.Gate > a.Gate ? -1 : 0));
                    gateSort = { gateSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) => (a.Gate < b.Gate ? 1 : b.Gate < a.Gate ? -1 : 0));
                    gateSort = { gateSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) => (a.Gate < b.Gate ? 1 : b.Gate < a.Gate ? -1 : 0));
                } else {
                    filteredFlights = filteredFlights.sort((a, b) => (a.Gate > b.Gate ? 1 : b.Gate > a.Gate ? -1 : 0));
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            { flightNumberSort: null },
                            { destinationSort: null },
                            { scheduleSort: null },
                            { terminalSort: null },
                            gateSort,
                            { statusSort: null },
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 7:
                value = this.state.statusSort;
                let statusSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Status > b.Status ? 1 : b.Status > a.Status ? -1 : 0,
                    );
                    statusSort = { statusSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Status < b.Status ? 1 : b.Status < a.Status ? -1 : 0,
                    );
                    statusSort = { statusSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Status < b.Status ? 1 : b.Status < a.Status ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.Status > b.Status ? 1 : b.Status > a.Status ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            { flightNumberSort: null },
                            { destinationSort: null },
                            { scheduleSort: null },
                            { terminalSort: null },
                            { gateSort: null },
                            statusSort,
                            { bagClaimSort: null },
                            sortColumn,
                        ),
                    );

                break;
            case 8:
                value = this.state.bagClaimSort;
                let bagClaimSort;
                if ((value === undefined || value === null || value === 0) && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.BagClaim > b.BagClaim ? 1 : b.BagClaim > a.BagClaim ? -1 : 0,
                    );
                    bagClaimSort = { bagClaimSort: inplace ? 0 : 1 };
                } else if (value === 1 && !inplace) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.BagClaim < b.BagClaim ? 1 : b.BagClaim < a.BagClaim ? -1 : 0,
                    );
                    bagClaimSort = { bagClaimSort: inplace ? 1 : 0 };
                } else if (inplace && value === 0) {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.BagClaim < b.BagClaim ? 1 : b.BagClaim < a.BagClaim ? -1 : 0,
                    );
                } else {
                    filteredFlights = filteredFlights.sort((a, b) =>
                        a.BagClaim > b.BagClaim ? 1 : b.BagClaim > a.BagClaim ? -1 : 0,
                    );
                }
                if (!inplace)
                    this.setState(
                        Object.assign(
                            this.state,
                            { filteredFlights },
                            { airlineSort: null },
                            { flightNumberSort: null },
                            { destinationSort: null },
                            { scheduleSort: null },
                            { terminalSort: null },
                            { gateSort: null },
                            { statusSort: null },
                            bagClaimSort,
                            sortColumn,
                        ),
                    );

                break;
            default:
                break;
        }
        return filteredFlights;
    };

    componentDidMount() {
        this.getFlightInfo();
        this.refresher = setInterval(this.getFlightInfo, 60 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.refresher);
    }

    toggleAD = (newValue: boolean) => {
        if (this.state.isArrival === newValue) {
            return;
        }
        this.filterArray(
            this.state.flights,
            this.state.defaultInput,
            this.state.citySelect,
            this.state.airlineSelect,
            newValue,
            this.state.terminalSelect,
            125,
        );
    };

    debounce = (func: any, wait: any, immediate: any) => {
        let timeout: any;
        return function () {
            //@ts-ignore
            let context = this,
                args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    setDefaultInput = this.debounce(
        (defaultInput: string) => {
            this.filterArray(
                this.state.flights,
                defaultInput,
                this.state.citySelect,
                this.state.airlineSelect,
                this.state.isArrival,
                this.state.terminalSelect,
                125,
            );
        },
        500,
        false,
    );

    setAirlineSelect = (airlineSelect: string) => {
        this.filterArray(
            this.state.flights,
            this.state.defaultInput,
            this.state.citySelect,
            airlineSelect,
            this.state.isArrival,
            this.state.terminalSelect,
            125,
        );
    };

    setCitySelect = (citySelect: string) => {
        this.filterArray(
            this.state.flights,
            this.state.defaultInput,
            citySelect,
            this.state.airlineSelect,
            this.state.isArrival,
            this.state.terminalSelect,
            125,
        );
    };

    setTerminalSelect = (terminalSelect: string) => {
        this.filterArray(
            this.state.flights,
            this.state.defaultInput,
            this.state.citySelect,
            this.state.airlineSelect,
            this.state.isArrival,
            terminalSelect,
            125,
        );
    };

    hasMatchCodeShare = (codeShares: string[], input: string) => {
        if (!codeShares) {
            return false;
        }
        //return codeShares.some((item) => item.slice(0, item.indexOf('#') - 1).toUpperCase().includes(input)) // don't match flight numbers
        return codeShares.some(item => item.toUpperCase().includes(input));
    };
    //@ts-ignore
    uniq = a => {
        var seen = {};
        var out = [];
        var len = a.length;
        var j = 0;
        for (var i = 0; i < len; i++) {
            var item = a[i];
            //@ts-ignore
            if (seen[item] !== 1) {
                //@ts-ignore
                seen[item] = 1;
                out[j++] = item;
            }
        }
        return out;
    };

    filterArray = (
        flights: Flight[],
        defaultInput = '',
        citySelect = '',
        airlineSelect = '',
        isArrival = true,
        terminalSelect = '',
        loadNumber = this.state.loadNumber,
        sortColumn = this.state.sortColumn,
        inplace = true,
    ) => {
        let filteredFlights: Flight[] = [];
        let newAirlineListState: string[] = [];
        let newCityList: string[] = [];
        const defaultInputUpper = defaultInput.toUpperCase();
        // flights = flights.map(item => Object.assign(item,{Destination: item.Destination.replace('/', ' / ')}))
        flights.forEach((item: Flight) => {
            if (
                defaultInput !== '' &&
                (item.Airline.toUpperCase().includes(defaultInputUpper) ||
                    this.hasMatchCodeShare(item.CodeShares, defaultInputUpper) ||
                    item.Flightnumber.startsWith(defaultInput) ||
                    item.Destination.toUpperCase().includes(defaultInputUpper))
            ) {
                filteredFlights.push(item);
            }

            newAirlineListState.push(item.Airline.toUpperCase());
            newCityList.push(item.Destination);
        });

        if (filteredFlights.length < 1 && defaultInput === '') {
            filteredFlights = flights;
        }

        filteredFlights = filteredFlights.filter(item => {
            //item.Destination = item.Destination.replace('/', ' / ');
            return (
                (airlineSelect === '' || item.Airline.toUpperCase().includes(airlineSelect)) &&
                (citySelect === '' || item.Destination.includes(citySelect)) &&
                (terminalSelect === '' || item.Terminal === terminalSelect) &&
                item.AD === (isArrival ? 'A' : 'D')
            );
        });

        newAirlineListState = this.uniq(newAirlineListState); //[...new Set(newAirlineListState)];
        newCityList = this.uniq(newCityList); //[...new Set(newCityList)];

        if (this.state.initialLoad && this.mainInput != null) {
            //@ts-ignore
            this.mainInput.current.value = defaultInput;
        }

        filteredFlights = filteredFlights.map(item => {
            // item.Destination = item.Destination.replace('/', ' / ');
            return item;
        });
        if (sortColumn !== undefined && sortColumn !== null) {
            filteredFlights = this.sortColumn(sortColumn, inplace, filteredFlights);
        }
        const filteredLength = filteredFlights.length;
        filteredFlights = filteredLength > loadNumber ? filteredFlights.slice(0, loadNumber) : filteredFlights;

        this.setState(
            Object.assign(
                this.state,
                { airlineList: newAirlineListState.sort() },
                { cityList: newCityList.sort() },
                { flights },
                { filteredFlights },
                { defaultInput },
                { airlineSelect },
                { citySelect },
                { isArrival },
                { terminalSelect },
                { initialLoad: false },
                { filteredLength },
                { loadNumber },
                { sortColumn },
            ),
        );
    };

    getFlightInfo = () => {
        fetch('https://apps.skyharbor.com/flightinformation')
            .then(response => response.json())
            .then(r => r.map((rr: Flight) => Object.assign(rr, { fn: parseInt(rr.Flightnumber, 10) })))
            .then(jsonResponse =>
                this.filterArray(
                    jsonResponse,
                    this.state.defaultInput,
                    this.state.citySelect,
                    this.state.airlineSelect,
                    this.state.isArrival,
                    this.state.terminalSelect,
                ),
            );
    };

    toggleModel = (modalModel: Flight) => {
        //@ts-ignore
        if (this.modalRef.current !== null)
            if (this.state.modalModel === undefined) {
                this.setState(
                    Object.assign(
                        this.state,
                        {
                            isDetailModalShowing: !this.state.isDetailModalShowing,
                        },
                        { modalModel },
                    ),
                );
                return;
            } else if (
                modalModel.ID + modalModel.Destination !==
                this.state.modalModel.ID + this.state.modalModel.Destination &&
                this.state.isDetailModalShowing
            ) {
                this.setState(Object.assign(this.state, { modalModel }));
                return;
            }
        this.setState(
            Object.assign(this.state, { isDetailModalShowing: !this.state.isDetailModalShowing }, { modalModel }),
        );
    };

    setModalModel = (modalModel: Flight) => {
        this.setState(
            Object.assign(this.state, { modalModel }),
        );
    }

    transititionDetailToSubStepOne = (forward: boolean) => {
        if (forward) {
            this.setState(
                Object.assign(this.state, {
                    isDetailModalShowing: false,
                    isSubStepOneModalShowing: true,
                    isSubStepTwoModalShowing: false,
                    isSubStepThreeModalShowing: false,
                }),
            );
            return;
        }
        this.setState(
            Object.assign(this.state, {
                isDetailModalShowing: true,
                isSubStepOneModalShowing: false,
                isSubStepTwoModalShowing: false,
                isSubStepThreeModalShowing: false,
            }),
        );
    };

    transititionToSubStepTwo = (forward: boolean, notificationMethod: number) => {
        if (forward) {
            this.setState(
                Object.assign(this.state, {
                    isDetailModalShowing: false,
                    isSubStepOneModalShowing: false,
                    isSubStepTwoModalShowing: true,
                    isSubStepThreeModalShowing: false,
                    notificationMethod,
                }),
            );
            return;
        }
        this.setState(
            Object.assign(this.state, {
                isDetailModalShowing: true,
                isSubStepOneModalShowing: false,
                isSubStepTwoModalShowing: false,
                isSubStepThreeModalShowing: false,
            }),
        );
    };

    transititionToSubStepThree = (forward: boolean) => {
        if (forward) {
            this.setState(
                Object.assign(this.state, {
                    isDetailModalShowing: false,
                    isSubStepOneModalShowing: false,
                    isSubStepTwoModalShowing: false,
                    isSubStepThreeModalShowing: true,
                }),
            );
            return;
        }
        this.setState(
            Object.assign(this.state, {
                isDetailModalShowing: false,
                isSubStepOneModalShowing: true,
                isSubStepTwoModalShowing: false,
                isSubStepThreeModalShowing: false,
            }),
        );
    };

    closeModal = () => {
        this.setState(
            Object.assign(this.state, {
                isDetailModalShowing: false,
                isSubStepOneModalShowing: false,
                isSubStepTwoModalShowing: false,
                isSubStepThreeModalShowing: false,
            }),
        );
    };

    render() {
        return (
            <div>
                <DetailModal
                    model={this.state.modalModel}
                    close={this.closeModal}
                    isShowing={this.state.isDetailModalShowing}
                    toggleModal={this.toggleModel}
                    navigationFunc={this.transititionDetailToSubStepOne}
                    notifications={this.state.notifications}
                />
                <SubStepOneModal
                    isShowing={this.state.isSubStepOneModalShowing}
                    close={this.closeModal}
                    flight={this.state.modalModel}
                    navigationFunc={this.transititionToSubStepTwo}
                />
                <SubStepTwoModal
                    isShowing={this.state.isSubStepTwoModalShowing}
                    close={this.closeModal}
                    model={this.state.modalModel}
                    setUserInfo={(userInfo: string) => this.setState(Object.assign(this.state, { userInfo }))}
                    notificationMethod={this.state.notificationMethod}
                    navigationFunc={this.transititionToSubStepThree}
                />
                <SubStepThreeModal userInfo={this.state.userInfo} isShowing={this.state.isSubStepThreeModalShowing} close={this.closeModal} />

                <TopControlF
                    ref={this.mainInput}
                    airlineList={this.state.airlineList}
                    cityList={this.state.cityList}
                    isArrival={this.state.isArrival}
                    showCodeShares={this.state.showCodeShares}
                    airlineSelectChange={e => this.setAirlineSelect(e.target.value)}
                    citySelectOnChange={e => this.setCitySelect(e.target.value)}
                    TerminalSelectedOnChange={e => this.setTerminalSelect(e.target.value)}
                    toggleAD={this.toggleAD}
                    toggleCodeShares={() =>
                        this.setState(
                            Object.assign(this.state, {
                                showCodeShares: !this.state.showCodeShares,
                            }),
                        )
                    }
                    //@ts-ignore
                    inputOnChange={e => this.setDefaultInput(e.target.value)}
                />

                <ResultHeader
                    airlineSort={this.state.airlineSort}
                    flightNumberSort={this.state.flightNumberSort}
                    destinationSort={this.state.destinationSort}
                    scheduleSort={this.state.scheduleSort}
                    terminalSort={this.state.terminalSort}
                    gateSort={this.state.gateSort}
                    statusSort={this.state.statusSort}
                    bagClaimSort={this.state.bagClaimSort}
                    sortColumn={(newSortcolumn: number) =>
                        this.filterArray(
                            this.state.flights,
                            this.state.defaultInput,
                            this.state.citySelect,
                            this.state.airlineSelect,
                            this.state.isArrival,
                            this.state.terminalSelect,
                            this.state.loadNumber,
                            newSortcolumn,
                            false,
                        )
                    }
                />

                {this.state.filteredFlights.map((item, index) => (
                    <ResultRow
                        key={item.ID + item.Destination}
                        item={item}
                        index={index}
                        navigationFunc={this.transititionDetailToSubStepOne}
                        showCodeShares={this.state.showCodeShares}
                        showModal={() => this.toggleModel(item)}
                        setModalModel={this.setModalModel}
                        notifications={this.state.notifications}
                    />
                ))}

                <div
                    className='row'
                    onClick={() => {
                        this.setState(
                            Object.assign(this.state, {
                                loadNumber: this.state.loadNumber + 50,
                            }),
                            () => {
                                this.filterArray(
                                    this.state.flights,
                                    this.state.defaultInput,
                                    this.state.citySelect,
                                    this.state.airlineSelect,
                                    this.state.isArrival,
                                    this.state.terminalSelect,
                                    this.state.loadNumber,
                                );
                            },
                        );
                    }}>
                    <div className='col-12' style={{ padding: '.75rem', textAlign: 'center' }}>
                        {this.state.filteredFlights.length > this.state.loadNumber - 1 ? (
                            <button className='btn btn-secondary'>Show next 50 flights</button>
                        ) : (
                                ''
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

let domContainer = document.querySelector('#flightSearchContainer');
if (!(domContainer === undefined || domContainer === null)) ReactDOM.render(<SearchPage />, domContainer);